import { type ApolloCache, ApolloClient } from "@apollo/client";
import { type GetCameraKitOrganizationsQuery } from "../api/query/getOrganizations.gql-generated";
import { getOrganizations } from "../api/query";
import { type CameraKitOrganization } from "../../../gql-generated/types";
import {
    searchOrganization,
    type SearchOrganizationsQuery,
    type SearchOrganizationsQueryVariables,
    type OrganizationQuery,
    getSelectedOrganization,
} from "../api/query";
import { type PartialBy } from "../../core/types/helpers";
import { EmptyOrganization } from "./EmptyOrganization";

type GenericOrganizationQuery = {
    // @ts-ignore
    selectedOrganization: PartialBy<OrganizationQuery["selectedOrganization"], "orgAuthorizedOperations">;
} & Pick<OrganizationQuery, "__typename">;

export interface OrganizationsCache {
    selectedOrganization: Readonly<CameraKitOrganization>;
}
export class OrganizationsRepository {
    public constructor(public apolloClient: ApolloClient<any>) {
        if (!this.apolloClient) {
            throw new Error("ApolloClient should be provided");
        }
    }

    public static initDefaults(cache: ApolloCache<any>) {
        cache.writeQuery<GenericOrganizationQuery>({
            query: getSelectedOrganization,
            data: {
                selectedOrganization: EmptyOrganization,
            },
        });
    }

    public setSelectedOrganizationId(organization: Readonly<CameraKitOrganization>) {
        this.apolloClient.writeQuery<GenericOrganizationQuery>({
            query: getSelectedOrganization,
            data: {
                selectedOrganization: organization,
            },
        });
    }

    public getSelectedOrganization() {
        const query = this.apolloClient.readQuery<GenericOrganizationQuery>({ query: getSelectedOrganization });
        return query?.selectedOrganization;
    }

    public getOrganizations() {
        const query = this.apolloClient.readQuery<GetCameraKitOrganizationsQuery>({ query: getOrganizations });
        return query?.getOrganizations?.organizations;
    }

    public searchOrganization(organizationId: string) {
        const query = this.apolloClient.readQuery<SearchOrganizationsQuery, SearchOrganizationsQueryVariables>({
            query: searchOrganization,
            variables: {
                query: organizationId,
            },
        });
        return query?.searchOrganizations?.organizations;
    }
}
